/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Compare_Event_Groups_Apply_A_To_B_TitleInputs */



/**
* | output |
* | --- |
* | "Apply changes from Group A to Group B" |
*
* @param {Compare_Event_Groups_Apply_A_To_B_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const compare_event_groups_apply_a_to_b_title = /** @type {((inputs?: Compare_Event_Groups_Apply_A_To_B_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Compare_Event_Groups_Apply_A_To_B_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Appliquer les modifications du groupe A au groupe B")
	if (locale === "de") return /** @type {LocalizedString} */ ("Änderungen von Gruppe A auf Gruppe B übertragen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Applica le modifiche dal Gruppo A al Gruppo B")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Перенесите изменения из группы А в группу В.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Aplicar cambios del Grupo A al Grupo B")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("将A组的变更应用到B组。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("グループAからグループBへの変更を適用する")
	if (locale === "hi") return /** @type {LocalizedString} */ ("समूह A से समूह B में परिवर्तन लागू करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Aplicar as alterações do Grupo A ao Grupo B.")
	return /** @type {LocalizedString} */ ("Apply changes from Group A to Group B")
});